<template>
    <zen-message-modal
        :isOpen="isOpen"
        title="Permission changes require re-login"
    >
        Your grants or teams have been updated. You need to log out and log back
        in for the changes to take effect. Would you like to log out now?
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Stay Logged In
            </zen-button>
            <zen-button
                variant="primary"
                size="medium"
                :processing="processing"
                @click="$emit('confirm')"
                data-testid="confirm-logout-button"
            >
                Log Out
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'LogoutPromptModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
